import { CoreIcon } from '../core-icon';
import infoCircleFillSVG from '../../assets/icons/info-circle-fill.svg';
import type { IconProps } from '../core-icon';

export const InfoCircleFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={infoCircleFillSVG} {...props} />;
};
